/* lib/api/urlBudget.js — помещается ли запрос в адресную строку.

   Строку запроса режет НЕ nginx и не Django, а gunicorn: `limit_request_line` по
   умолчанию 4094 байта, и превышение возвращается кодом 400 ещё ДО приложения.
   Ни один обработчик о таком запросе не узнаёт, в логах приложения его нет, а
   пользователь видит «Что-то пошло не так» и кнопку «Повторить», которая шлёт тот
   же самый адрес — тупик без выхода.

   Так ломался ABC-анализ: выбор 55 групп у «Мезона» (109 групп за квартал) дал
   строку запроса в 4186 байт — кириллица в адресе кодируется по шесть символов на
   букву. Поднимать лимит бессмысленно: у одного из подключений 895 групп, это
   десятки килобайт. Такие параметры возят телом, а не адресом.

   Потолок берём с запасом — 3000 против 4094. Цена ошибки несимметрична: лишний
   раз уйти телом не стоит ничего, не уйти вовремя — сломать экран целиком.
   Длину считаем в символах: адрес после encodeURIComponent — чистый ASCII,
   поэтому символы здесь равны байтам. */

export const MAX_GET_URL = 3000;

/** Поместится ли путь с query-строкой в адрес (иначе параметры — телом POST). */
export function fitsInGetUrl(url) {
  return String(url || '').length <= MAX_GET_URL;
}
